import { ApiClientService } from '@dfl/react-security';
import { IAuditField } from 'modules/audit/management/interfaces/IAuditField';
import { isEmptyFieldValue } from 'modules/audit/management/utils/isEmptyFieldValue';
import EntityApiServicePopulate from 'utils/EntityApiServicePopulate';
import { IAuditPopulated } from '../interfaces/IAuditPopulated';

const normalizeValues = (generalInfo: IAuditField[]) =>
  generalInfo.map((item) => ({ ...item, value: isEmptyFieldValue(item.value) ? '' : item.value }));

class AuditService extends EntityApiServicePopulate<IAuditPopulated> {
  duplicate = (auditId: string) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${auditId}/duplicate`), {}));
  };

  addField = (auditId: string, generalInfo: IAuditField[], field: IAuditField) => {
    generalInfo.push(field);
    return this.update(auditId, { _id: auditId, generalInfo: normalizeValues(generalInfo) });
  };

  removeField = (auditId: string, generalInfo: IAuditField[], fieldId: number) => {
    generalInfo = generalInfo.filter((f, index) => index !== fieldId) || [];
    return this.update(auditId, { _id: auditId, generalInfo: normalizeValues(generalInfo) });
  };

  updateField = (auditId: string, generalInfo: IAuditField[], index: number, newData: Partial<IAuditField>) => {
    const field = generalInfo[index];
    if (!field) {
      throw new Error('field not found');
    }
    Object.assign(field, newData);
    return this.update(auditId, { _id: auditId, generalInfo: normalizeValues(generalInfo) });
  };

  saveFromTemplate = (templateId: string, data: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${templateId}/template`), data));
  };

  init = (auditId: string) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${auditId}/init`), {}));
  };

  complete = (auditId: string) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${auditId}/complete`), {}));
  };

  saveAsTemplate = (auditId: string) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${auditId}/save-template`), {}));
  };

  duplicateAudit = (auditId: string) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${auditId}/duplicate`), {}));
  };
}

export default new AuditService('/ms-core/api/audit');
